<template>
  <div v-if="visible" class="ph2-cs-float" @click="goTelegram">
    <i class="el-icon-service" />
    <span>{{ $t('fields.onlineCustomerService') }}</span>
    <span class="ph2-cs-float-close" @click.stop="close">
      <el-icon :size="12"><Close /></el-icon>
    </span>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Close } from '@element-plus/icons-vue'
import { useStore } from '@/store'
import { siteEnum } from '@/consts/SiteEnum'

const TELEGRAM_URL = 'https://t.me/B9_GAME'
const CLOSED_KEY = 'ph2CsFloatClosed'

const store = useStore()

const isClosed = () => {
  try {
    return !!sessionStorage.getItem(CLOSED_KEY)
  } catch (e) {
    return false
  }
}

const visible = ref(
  Number(store.state.user.siteId) === Number(siteEnum.PH2) && !isClosed()
)

const close = () => {
  visible.value = false
  try {
    sessionStorage.setItem(CLOSED_KEY, '1')
  } catch (e) {
    // storage unavailable: closes for this mount only
  }
}

const goTelegram = () => {
  window.open(TELEGRAM_URL, '_blank', 'noopener')
}
</script>

<style lang="scss" scoped>
// same look as the PH2 login page's .ph2-cs-entry
.ph2-cs-float {
  position: fixed;
  right: 20px;
  bottom: 30px;
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 24px;
  background: #458bff;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  &:hover {
    opacity: 0.9;
  }
}

.ph2-cs-float-close {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ffffff;
  color: #5a5e66;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}
</style>
